<template>
    <div class="content-center none-click">
      <div class="banner">
        <div class="banner_box">
            <div class="banner_title">千橙RPA工具箱</div>
            <div class="banner_line"></div>
            <!-- <div class="banner_title2">打造以业务员为核心的超级业务员管理系统</div> -->
            <div class="banner_text" style="margin-top: 22px;">RPA是指机器人流程自动化，就是让它们去做有规律的重复流程。</div>
        </div>
        <img src="@/assets/Mobile/images/QcTool/banner.png" alt="">
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">模拟人实现各种自动化操作 ，释放各种有逻辑规则 、重复性的人工工作</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcTool/programme1.png" alt="">
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">提供<span class="title_text_color">6</span>大场景，<span  class="title_text_color">25+</span>流程应用，辅助自动化运营，提升运营效率，降低人为失误</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcTool/programme2.png" alt="">
        </div>
      </div>
      <div class="tool">
        <div class="sk-mobile-title" style="margin-bottom: 20px;">
          <div class="title">操作步骤少，效率提升大</div>
        </div>
        <div class="content">
            <div class="content_top">
                <div class="step_num" :class="tooItem=='1'?'step_bg2':'step_bg1'">01</div>
                <img src="@/assets/Mobile/images/QcTool/step_line.png" alt="">
                <div class="step_num" :class="tooItem=='2'?'step_bg2':'step_bg1'">02</div>
                <img src="@/assets/Mobile/images/QcTool/step_line.png" alt="">
                <div class="step_num" :class="tooItem=='3'?'step_bg2':'step_bg1'">03</div>
                <img src="@/assets/Mobile/images/QcTool/step_line.png" alt="">
                <div class="step_num" :class="tooItem=='4'?'step_bg2':'step_bg1'">04</div>
            </div>
            <div class="content_btn">
                <div class="btn_top">
                    <div :class="tooItem=='1'?'btn_box1':'btn_box'" @click="checkBg('1')">
                        <div class="btn_line"></div>
                        <div class="btn_title">准备数据</div>
                    </div>
                    <div :class="tooItem=='2'?'btn_box1':'btn_box'" @click="checkBg('2')">
                        <div class="btn_line"></div>
                        <div class="btn_title">流程配置</div>
                    </div>
                    <div :class="tooItem=='3'?'btn_box1':'btn_box'" @click="checkBg('3')">
                        <div class="btn_line"></div>
                        <div class="btn_title">自动化执行</div>
                    </div>
                    <div :class="tooItem=='4'?'btn_box1':'btn_box'" @click="checkBg('4')">
                        <div class="btn_line"></div>
                        <div class="btn_title">结果反馈</div>
                    </div>
                </div>
                <div class="btn_bottom" v-if="tooItem=='1'">准备需要执行的数据</div>
                <div class="btn_bottom" v-if="tooItem=='2'">填写配置信息</div>
                <div class="btn_bottom" v-if="tooItem=='3'">系统自动化</div>
                <div class="btn_bottom" v-if="tooItem=='4'">反馈执行数据</div>
            </div>
            <div class="content_bg">
                <img v-if="tooItem=='1'" src="@/assets/Mobile/images/QcTool/tool1.png" alt="">
                <img v-if="tooItem=='2'" src="@/assets/Mobile/images/QcTool/tool2.png" alt="">
                <img v-if="tooItem=='3'" src="@/assets/Mobile/images/QcTool/tool3.png" alt="">
                <img v-if="tooItem=='4'" src="@/assets/Mobile/images/QcTool/tool4.png" alt="">
            </div>
        </div>
      </div>
      <div class="programme" style="background:rgba(234,243,255,.67)">
        <div class="sk-mobile-title">
          <div class="title">客户案例</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcTool/case1.png" alt="">
            <img src="@/assets/Mobile/images/QcTool/case2.png" alt="">
        </div>
      </div>
      <Case title="微商城" />
      <ContactForm info-sources="千橙RPA工具箱" />
      <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="千橙RPA工具箱" @cancel="modalClose" />
  
    </div>
  </template>
  
  <script>
  import metaInfo from '@/common/util/metaInfo'
  import ContactForm from '@/Mobile/Mobilecom/ContactForm'
  import IndustrySolution from '@/Mobile/Mobilecom/IndustrySolution'
  import Case from '@/Mobile/Mobilecom/Case'
  import TryModal from '@/Mobile/Mobilecom/TryModal'
  
  export default {
    metaInfo: metaInfo.QcTool,
    components: {
      ContactForm,
      IndustrySolution,
      Case,
      TryModal
    },
    data() {
      return {
        tryVisible: false,
        tooItem:'1',
      }
    },
    mounted() {
  
    },
    methods: {
      linkTo(path) {
          this.$router.push({ path: '/m/' + path })
          this.$nextTick(() => {
              this.open = false
          })
      },
      checkBg(item) {
        this.tooItem = item;
      },
      openModal: function() {
        this.tryVisible = true
      },
      modalClose: function(data) {
        this.tryVisible = data
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .programme1{
    background: #f8f8fd;
  }
  .tool{
    background-color:#f7f8fd;
    padding:0 16px;
    .content{
        display: flex;
        flex-direction: column;
        align-items: center;
        .content_top{
            width: 300px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            .step_num{
                width: 23px;
                height: 28px;
                font-size: 11px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                text-align: center;
                line-height: 20px;
            }
            img{
                width: 38px;
                height: 14px;
            }
            .step_bg1{
                background: url('~@/assets/Mobile/images/QcTool/step1.png');
                background-size: 100% 100%;
            }
            .step_bg2{
                background: url('~@/assets/Mobile/images/QcTool/step2.png');
                background-size: 100% 100%;
            }
        }
        .content_btn{
            width: 328px;
            height: 73px;
            margin-top: 7px;
            .btn_top{
                height:32px;
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                .btn_box{
                    width: 76px;
                    height: 32px;
                    background: #F0F0F0;
                    border-radius: 8px 8px 0px 0px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    .btn_line{
                        width: 3px;
                        height: 9px;
                        background: #CCCCCC;
                        border-radius: 2px;
                    }
                    .btn_title{
                        font-size: 12px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 500;
                        color: #999999;
                        line-height: 32px;
                        margin-left: 4px;
                    }
                }
                .btn_box1{
                    width: 76px;
                    height: 32px;
                    background: #E3EFFF;
                    border-radius: 8px 8px 0px 0px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    .btn_line{
                        width: 3px;
                        height: 9px;
                        background: linear-gradient(360deg, #6BBBFF 0%, #3986FF 100%);
                        border-radius: 2px;
                    }
                    .btn_title{
                        font-size: 12px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 500;
                        color: #333333;
                        line-height: 32px;
                        margin-left: 4px;
                    }
                }
            }
            .btn_bottom{
                height:41px;
                width: 328px;
                padding:12px 13px;
                background: #E3EFFF;
                font-size: 12px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 17px;
                text-align: left;
            }
        }
        .content_bg{
            // height:231px;
            margin-top: 30px;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
  }
  .banner_box{
    position: absolute;
    top: 25px;
    left:16px;
    .banner_title{
        height: 25px;
        font-size: 18px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 25px;
        text-align: left;
    }
    .banner_title2{
        width: 142px;
        height: 28px;
        font-size: 10px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 14px;
        margin-top: 9px;
        text-align: left
    }
    .banner_line{
        width: 50px;
        height: 3px;
        background: #28DAFB;
        margin-top:6px;
        
    }
    .banner_text{
        margin-top:8px;
        width: 134px;
        height: 78px;
        font-size: 7px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 13px;
        text-align: left
    }
  }
  .banner {
    width: 100%;
    height: 200px;
    margin-top: 50px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
 
  </style>
  